$ = require 'jquery'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
log = require 'app/scripts/debug/log'

module.exports = class CollectionView extends View
  initialize: ->
    @listenPropagators = {}

    @makeDebouncedMethods 'sort'

    @listenTo @collection,
      'sort': @sortDebounced
      'add': @addModel
      'remove': @removeModel
      'reset': @reset

    super

  getModels: ->
    @collection.models

  # Override the subview method to register a blanket listener that will
  # propagate all subview-triggered events to trigger on the CollectionView.
  subview: ->
    view = super
    # @subview gets called a lot, so make sure we only register this once
    @listenPropagators[view.cid] ?=
      @listenTo view, 'all', (event, args...) =>
        @trigger(event, view, args...)
    return view

  addModel: (model, options) ->
    log('render', "adding #{@collection.model.name} to #{@viewType.name}")
    view = @subview(@viewType, model)
    if @el
      @insertSubview(view, _.indexOf(@getModels(), model))
    return

  removeModel: (model, options) ->
    log('render', "removing #{@collection.model.name} from #{@viewType.name}")
    @removeSubview @viewForModel(model)

  reset: (collection, { previousModels }) ->
    keptModels = {}
    for model in collection.models
      keptModels[model.cid] = true
    for model in previousModels when !keptModels[model.cid]
      @removeModel(model)
    @sort()

  sort: =>
    placeHolderIndices = Array.from(@el.children)
    .map (el, index) ->
      if el.matches('.placeholder,.card-composer')
        index
      else
        null
    .filter((index) -> index != null)

    for model, index in @getModels()
      effectiveIndex =
        index + placeHolderIndices.filter((placeholderIndex) ->
          placeholderIndex <= index
        ).length
      @moveSubviewToPosition(@subview(@viewType, model), effectiveIndex)

    return

  render: ->
    log('render', "rendering #{@getModels().length} #{@collection.model.name}s into #{@viewType.name}")
    @appendSubviews(@subview(@viewType, model) for model in @getModels())
    @

  viewForModel: (model) ->
    @existingSubview @viewType, model

  removeSubview: (subview) ->
    @deleteSubview subview

  insertSubview: (subview, target, $el = @$el) ->
    log('render', "inserting #{ subview.$el.find('h2').text() } at position #{ target }")
    # Turn target from an index or a view into an element
    if typeof target == "number"
      if target <= 0
        target = $el.children().eq(0)
      else if target < $el.children().length
        target = $el.children().eq(target)
      else
        target = undefined
    else if target instanceof View
      target = target.$el

    if subview.$el.is(':empty')
      # If the subview's $el is empty, it hasn't been rendered, so render it
      subview.delegateEvents()
      subview.render()

    if target?.length > 0
      subview.$el.insertBefore(target)
    else
      $el.append(subview.$el)

    return

  moveSubviewToPosition: (subview, position) ->
    if subview.$el.is(':empty')
      # If the subview hasn't been rendered, it needs to also be inserted
      @insertSubview subview, position, @$el
      return

    children = @el.children

    currentPosition = subview.$el.index()
    return if currentPosition == position

    if position == 0
      @$el.prepend(subview.$el)
    else if position >= children.length
      @$el.append(subview.$el)
    else
      subview.$el.insertAfter(children[position - 1])

    return
